import React, { useEffect, useState } from "react";
// import { ReactComponent as EnterKey} from "Assets/enter-key.svg";
// import enterKeyWhite from "Assets/enter-key-white.svg"
import styles from "Styles/components/keyboard-hint.module.css";
import classNames from "classnames";

const KeyboardHint = ({ keyName = "Enter", keyIcon, keyCode = 13 }) => {
  const [visible, setVisible] = useState(false);
  const [hint, setHint] = useState(true);

  const keyboardHintWrapperClassNames = classNames(styles.keyboardHintWrapper, {
    [styles.keyboardHintFadeOut]: !hint,
    [styles.keyboardHintHidden]: !visible,
  });

  useEffect(() => {
    const detectKey = (e) => {
      if (e.keyCode === keyCode) {
        setHint(false);
      }
    };
    document.addEventListener("keydown", detectKey, true);
    return () => {
      document.removeEventListener("keydown", detectKey, true);
    };
  }, [keyCode]);

  useEffect(() => {
    const handleFocusIn = () => {
      const active = document.activeElement;
      if (!active) return;
      const tag = active.tagName.toLowerCase();
      if (
        tag === "input" ||
        tag === "textarea" ||
        tag === "select" ||
        tag === "label"
      ) {
        setVisible(true);
        setHint(true);
      }
    };

    const handleFocusOut = (e) => {
      // Only hide if focus moves outside all form elements
      const related = e.relatedTarget;
      if (!related) {
        setVisible(false);
        return;
      }
      const tag = related.tagName.toLowerCase();
      if (
        tag !== "input" &&
        tag !== "textarea" &&
        tag !== "select" &&
        tag !== "label" &&
        tag !== "button"
      ) {
        setVisible(false);
      }
    };

    document.addEventListener("focusin", handleFocusIn);
    document.addEventListener("focusout", handleFocusOut);
    return () => {
      document.removeEventListener("focusin", handleFocusIn);
      document.removeEventListener("focusout", handleFocusOut);
    };
  }, []);
  const svgFill = window.innerWidth >= 768 ? "#606060 " : "#ffffff";

  return (
    <>
      <div className={keyboardHintWrapperClassNames}>
        <p className={styles.keyboardHintText}>
          press <strong>{keyName}</strong>
        </p>
        {/* <img className={styles.keyboardHintIcon} src={svgIcon} alt="key icon" />  */}
        <div className={styles.keyboardHintIcon}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="11"
            height="11"
            viewBox="0 0 11 12"
          >
            <path
              fill={svgFill}
              d="M2.96867 6.02226c.08327-.08278.19592-.12924.31334-.12924.11741 0 .23006.04646.31333.12924.08278.08327.12924.19592.12924.31333 0 .11742-.04646.23006-.12924.31334L1.91089 8.33337h8.08889V.68004c0-.117874.04682-.23092.13022-.31427.0833-.083349.1964-.130174.3142-.130174.1179 0 .2309.046825.3143.130174.0833.08335.1302.196396.1302.31427v7.65333c0 .23575-.0937.46184-.2604.62854-.1667.1667-.3928.26035-.62852.26035H1.93312l1.66222 1.66664c.08278.0833.12924.1959.12924.3134 0 .1174-.04646.23-.12924.3133-.08278.0821-.19452.1284-.31111.1289-.05849.0003-.11648-.0109-.17063-.033-.05415-.0221-.1034-.0547-.14493-.0959L.222006 8.77782 2.96867 6.02226Z"
            />
          </svg>
        </div>
      </div>
    </>
  );
};

export default KeyboardHint;
